import React from 'react';
import {PagedRoute} from 'app/appRoutes';
import {Pagination, PaginationItem, PaginationLink} from 'reactstrap';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

interface Props {
    params: PagedRoute,
    pageCount: number,
    getRoute: (pageNum: number) => string
}

const PaginationBar: React.FC<Props> = ({pageCount, params, getRoute}) => {

    const page = (parseInt(params.page) || 0) + 1;
    
    const renderPaginationLink = (pageNum: number) => <PaginationItem key={pageNum} className={classNames({'active': page === pageNum})}>
        <PaginationLink tag={Link} to={getRoute(pageNum)}>{pageNum}</PaginationLink>
    </PaginationItem>;

    const renderPages = () => {
        const res:JSX.Element[] = [];
        const maxPages = 10;
        const maxPrevNextPages = Math.floor(maxPages / 2);
        const prevPages = page - 1;
        const nextPages = pageCount - page;
        const showPrevPages = prevPages > maxPrevNextPages ? maxPrevNextPages : prevPages;
        const showNextPages = nextPages > maxPrevNextPages ? maxPrevNextPages : nextPages;

        for (let i = page - showPrevPages; i <= page; i++) {
            res.push(renderPaginationLink(i));
        }
        for (let i = page + 1; i <= page + showNextPages; i++) {
            res.push(renderPaginationLink(i));
        }

        return res;
    }

    return <Pagination>
        <PaginationItem className={classNames({'disabled': page < 2})}><PaginationLink first tag={Link} to={getRoute(1)} /></PaginationItem>
        <PaginationItem className={classNames({'disabled': page < 2})}><PaginationLink previous tag={Link} to={getRoute(page - 1)} /></PaginationItem>
        {renderPages()}
        <PaginationItem className={classNames({'disabled': page >= pageCount})}><PaginationLink next tag={Link} to={getRoute(page + 1)} /></PaginationItem>
        <PaginationItem className={classNames({'disabled': page >= pageCount})}><PaginationLink last tag={Link} to={getRoute(pageCount)} /></PaginationItem>
    </Pagination>;
}

export default PaginationBar;